var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#C7E9F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.82 14.1735L15.1267 13.9802C14.9276 13.9568 14.7258 13.9788 14.5364 14.0446C14.347 14.1105 14.175 14.2183 14.0334 14.3602L12.8067 15.5868C10.9143 14.6241 9.37607 13.0859 8.41336 11.1935L9.64669 9.96017C9.93336 9.6735 10.0734 9.2735 10.0267 8.86684L9.83336 7.18684C9.7957 6.86156 9.63967 6.56152 9.395 6.3439C9.15033 6.12628 8.83414 6.0063 8.50669 6.00684H7.35336C6.60003 6.00684 5.97336 6.6335 6.02003 7.38684C6.37336 13.0802 10.9267 17.6268 16.6134 17.9802C17.3667 18.0268 17.9934 17.4002 17.9934 16.6468V15.4935C18 14.8202 17.4934 14.2535 16.82 14.1735Z",
    fill: "#00B9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCircle);
export default __webpack_public_path__ + "static/media/call_circle.91f1b56beb038f51e5df3902cfd3213d.svg";
export { ForwardRef as ReactComponent };